import { GraphConfig } from '../'
import { branch } from '../constants'

module.exports = (transaction) ->
  { className } = GraphConfig
  configNode = new Weaver.Node(className)
  configNode.set('name', className)
  await configNode.save({ transaction, branch, commitMessage: "Add Graph Config Migration." })
  graphConfig = new GraphConfig()
  graphConfig.setNodeLimit(5000, { transaction, branch })
  await graphConfig.save({ transaction, branch })
